import React, { useState } from "react";
import { Box, Typography, Paper, Stack } from "@mui/material";
import WifiIcon from "@mui/icons-material/Wifi";
import TvIcon from "@mui/icons-material/Tv";
import KitchenIcon from "@mui/icons-material/Kitchen";
import LocalLaundryServiceIcon from "@mui/icons-material/LocalLaundryService";
import LocalParkingIcon from "@mui/icons-material/LocalParking";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";

const Sidebarlayout = ({ unit }) => {
  const [selectedSection, setSelectedSection] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const iconMapping = {
    "Wi-Fi": <WifiIcon style={{ color: "var(--pri-col)" }} />,
    "TV": <TvIcon style={{ color: "var(--pri-col)" }} />,
    "Kitchen": <KitchenIcon style={{ color: "var(--pri-col)" }} />,
    "Washer": <LocalLaundryServiceIcon style={{ color: "var(--pri-col)" }} />,
    "Free Parking": <LocalParkingIcon style={{ color: "var(--pri-col)" }} />,
  };



  return (
    <Box sx={{ display: "flex", height: "100vh", overflowY: "auto", }}>
      {/* Sidebar */}
      <Box sx={{ width: "30%", borderRight: "1px solid #ddd", overflowY: "auto", p: 2, backgroundColor: "#ffffff" }}>
        <Typography variant="h6" sx={{ mb: 2 }}>Unit Overview</Typography>

        <Paper onClick={() => setSelectedSection("Photos")} elevation={3} sx={{ mb: 2, p: 2, borderRadius: 2, border: "1px solid #ddd", backgroundColor: "white", cursor: "pointer" }}>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>Photos</Typography>
          <Box sx={{ width: "100%", overflow: "hidden", position: "relative", paddingY: 2 }}>
            <Swiper
              spaceBetween={-50} // التداخل بين الصور
              slidesPerView={2.5} // عدد الصور المرئية جزئيًا
              centeredSlides // يجعل الصورة النشطة في المنتصف
              loop
              onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)} // تحديث الفهرس النشط
            >
              {unit.images.map((img, index) => (
                <SwiperSlide key={index} style={{ position: "relative" }}>
                  <Box
                    component="img"
                    src={img.image}
                    alt={`unit-image-${index}`}
                    sx={{
                      width: activeIndex === index ? "100%" : "80%", // تكبير الصورة الأمامية فقط
                      height: activeIndex === index ? "220px" : "180px", // تكبير الصورة الأمامية فقط
                      borderRadius: "12px",
                      objectFit: "cover",
                      transition: "all 0.4s ease-in-out",
                      transform: activeIndex === index ? "scale(1.1)" : "scale(0.9)", // تكبير الصورة الأمامية
                      boxShadow: activeIndex === index ? "0 6px 12px rgba(0,0,0,0.3)" : "0 3px 6px rgba(0,0,0,0.15)",
                      zIndex: activeIndex === index ? 2 : (index > activeIndex ? 1 : 0), // الصورة الأمامية في المقدمة، والصور اليمنى في المقدمة
                      marginLeft: activeIndex !== index ? "50px" : "0", // تحريك الصور للخلف قليلًا
                      marginRight: activeIndex !== index ? "50px" : "0",
                    }}
                  />
                </SwiperSlide>
              ))}

            </Swiper>
          </Box>
        </Paper>

        <Paper onClick={() => setSelectedSection("Description")} elevation={3} sx={{ mb: 2, p: 2, borderRadius: 2, border: "1px solid #ddd", backgroundColor: "white", cursor: "pointer" }}>
          <Typography variant="h6" sx={{ mb: 1, fontWeight: "bold" }}>Description</Typography>
          <Typography variant="body2" color="text.secondary">{unit.description}</Typography>
        </Paper>

        <Paper onClick={() => setSelectedSection("Unit Type")} elevation={3} sx={{ mb: 2, p: 2, borderRadius: 2, border: "1px solid #ddd", backgroundColor: "white", cursor: "pointer" }}>
          <Typography variant="h6" sx={{ mb: 1, fontWeight: "bold" }}>Unit Type</Typography>
          <Typography variant="body2" color="text.secondary">{unit.unit_type}</Typography>
        </Paper>

        <Paper elevation={3} sx={{ mb: 2, p: 2, borderRadius: 2, border: "1px solid #ddd", backgroundColor: "white", cursor: "pointer" }}>
          <Typography variant="h6" sx={{ mb: 1, fontWeight: "bold" }}>Location</Typography>

          <iframe
            src={`https://www.google.com/maps?q=${unit.lat},${unit.lng}&hl=es;z=14&output=embed`}
            width="100%"
            height="300"
            style={{ borderRadius: "8px", border: "none" }}
            allowFullScreen
            loading="lazy"
          ></iframe>

        </Paper>



        <Paper elevation={3} sx={{ mb: 2, p: 2, borderRadius: 2, border: "1px solid #ddd", backgroundColor: "white", cursor: "pointer" }}>
          <Typography variant="h6" sx={{ mb: 1, fontWeight: "bold" }}>Amenities</Typography>
          <Stack>
            {unit.features.map((feature, index) => (
              <Stack key={index} direction="row" alignItems="center" spacing={1}>
                <Box
                  component="img"
                  src={feature.icon} // استخدم الرابط المباشر للأيقونة
                  alt={feature.name}
                  sx={{ width: 24, height: 24 }} // يمكنك تخصيص الحجم هنا
                />
                <Typography variant="body2" color="text.secondary">{feature.name}</Typography>
              </Stack>
            ))}
          </Stack>
        </Paper>

      </Box>

      {/* Details View */}
      <Box sx={{width:"70%", flexGrow: 1, overflow: "hidden", p: 2, backgroundColor: "#fff" }}>
        {selectedSection === "Photos" && (
          <>
            <Typography variant="h5" sx={{ mb: 2 }}>Photos</Typography>
            <Box sx={{width:"100%", display: "flex",flexWrap: "wrap", gap: 3 }}>
              {unit.images.map((img, index) => (
                <img key={index} src={img.image} alt={`unit-image-${index}`} style={{width:"calc(33.33% - 1rem)", borderRadius: 8, height: "250px" }} />
              ))}
            </Box>
          </>
        )}
        {selectedSection === "Description" && (
          <>
            <Typography variant="h5" sx={{ mb: 2 }}>Description</Typography>
            <Typography>{unit.description}</Typography>
          </>
        )}
        {selectedSection === "Unit Type" && (
          <>
            <Typography variant="h5" sx={{ mb: 2 }}>Unit Type</Typography>
            <Typography>{unit.unit_type}</Typography>
          </>
        )}
        {selectedSection === "Location" && (
          <>
            <Typography variant="h5" sx={{ mb: 2 }}>Location</Typography>
            <img src="/assets/map.png" alt="Location Map" style={{ width: "100%", borderRadius: 8 }} />
          </>
        )}
        {selectedSection === "Amenities" && (
          <>
            <Typography variant="h5" sx={{ mb: 2 }}>Amenities</Typography>
            {unit.features.map((feature, index) => (
              <Typography key={index}>{feature}</Typography>
            ))}
          </>
        )}
        {!selectedSection && (
          <Typography variant="h6" color="gray">Please select a section to view details.</Typography>
        )}
      </Box>
    </Box>
  );
};

export default Sidebarlayout;
